export default __webpack_public_path__ + "static/route-de-la-soie-a6c5043f6fe5b1c3e4b7c72449600951.png";